export const RecommendedBracketsData = {
  'Asphalt Shingles': {
    'New Construction': {
      'Snow Bracket D - Apex': 1,
      'Snow Bracket F - Apex': 2
    },
    Retrofit: {
      'Snow Bracket H - Apex': 1,
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  },
  'Cedar Shingles': {
    'New Construction': {
      'Snow Bracket D - Apex': 1,
      label: 'Snow Bracket Type'
    },
    Retrofit: {
      'Snow Bracket H - Apex': 1,
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  },
  'Concrete/Clay Tile': {},
  'Corrugated Metal': {
    'Snow Bracket I (Crest) - Apex': 1,
    'Snow Bracket I (Valley) - Apex': 2,
    label: 'Snow Bracket Type'
  },
  'Flat Seam Metal': {
    'New Construction': {
      'Snow Bracket G 9.5 - Apex': 1,
      'Snow Bracket H - Apex': 2
    },
    Retrofit: {
      'Snow Bracket H - Apex': 1,
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  },
  'Metal Panel': { 'Snow Bracket H - Apex': 1 },
  label: 'Snow Bracket Type',
  'Metal Shingles': {
    'Snow Bracket J - Apex': 1,
    'Snow Bracket G 9.5 - Apex': 2,
    label: 'Snow Bracket Type'
  },
  'Simulated Slate': {
    'New Construction': {
      'Snow Bracket F - Apex': 2,
      'Snow Bracket D - Apex': 1,
      label: 'Snow Bracket Type'
    },
    Retrofit: {
      'Snow Bracket H - Apex': 1,
      'Snow Bracket G 9.5 - Apex': 2,
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  },
  Slate: {
    'New Construction': {
      'Snow Bracket F - Apex': 1,
      'Snow Bracket F (Extended) - Apex': 2,
      label: 'Snow Bracket Type'
    },
    Retrofit: {
      'Snow Bracket Slate Hook - Apex': 1,
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  },
  'Standing Seam': {
    'Snow Bracket H - Apex': 1,
    'Snow Bracket G 9.5 - Apex': 2,
    label: 'Snow Bracket Type'
  },
  'Wood Shakes': {
    'New Construction': {
      'Snow Bracket F - Apex': 1,
      'Snow Bracket F (Extended) - Apex': 2,
      label: 'Snow Bracket Type'
    },
    Retrofit: {
      'Snow Bracket H - Apex': 1,
      'Snow Bracket G 9.5 - Apex': 2,
      label: 'Snow Bracket Type'
    },
    label: 'Construction Type'
  }
};
